import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import { useState } from 'react';

var useSteps = function useSteps(steps, initialStepValues, initialStep) {
  var _useState = useState(initialStep),
    _useState2 = _slicedToArray(_useState, 2),
    currentStep = _useState2[0],
    setCurrentStep = _useState2[1];
  // To make multi step forms work the original idea was to render radio fields
  // that looked like buttons by styling their label. When you click the label it
  // should select the radio field associated with that label. For some reason this
  // wasn't working. The fields weren't making it to the final form submission.
  // Probably due to something with the conditional rendering of the steps.
  // The quick fix we came up with is to track each steps values using our own
  // state and then combining that with the actual form values on submit.
  var _useState3 = useState(initialStepValues),
    _useState4 = _slicedToArray(_useState3, 2),
    stepValues = _useState4[0],
    setStepValues = _useState4[1];
  var nextStep = function nextStep(event, name, value) {
    if (currentStep < steps.length) {
      setStepValues(_objectSpread2(_objectSpread2({}, stepValues), {}, _defineProperty({}, name, value)));
      setCurrentStep(currentStep + 1);
    }
  };
  return {
    nextStep: nextStep,
    currentStep: currentStep,
    stepValues: stepValues
  };
};
var useSteps$1 = useSteps;

export { useSteps$1 as default };
//# sourceMappingURL=useSteps.js.map
